import React ,{ useState }from 'react';
import { useForm } from 'react-hook-form';
import {createLogEntry} from '../API';
const LogEntryForm = ({location, onClose, getEntries}) =>{
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState('');
      const { register, handleSubmit} = useForm();
      const onSubmit = async (data) =>{
          try{
              setLoading(true);

              data.latitude = location[0];
              data.longitude = location[1];
              await createLogEntry(data);
              onClose();
              getEntries();
          }catch(error){
              console.error(error);
              setError(error.message);
              setLoading(false);
          }
      };
    return(
        <form onSubmit={handleSubmit(onSubmit)} className="entry-form">
            {error ? <h3 className = "error-text">{error}</h3> : null}
            <label htmlFor="title">Title</label>
            <input name="title" required ref={register}/>
            <label htmlFor="comments">Comments</label>
            <textarea name="comments" rows ={3} ref={register}/>
            <label htmlFor="description">Description</label>
            <textarea name="description" rows={3} ref={register}/>
            <label htmlFor="image">Image URL</label>
            <input name="image" ref={register}/>
            <label htmlFor="visitDate">Visit Date</label>
            <input name="visitDate" type="date" required ref={register}/>
            <button disabled = {loading}>{loading ? 'Loading...' : 'Create Entry'}</button>
        </form>
    );

}

export default LogEntryForm;